import * as styles from './styles.css';

export const Wrapper: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <div className={styles['container']}>{children}</div>;
};

Wrapper.displayName = 'Wrapper';
